// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-block;
}
:host .badge {
  background: #5dade0;
  border: 1px solid #5dade0;
  color: #fff;
  font-size: 0.75rem;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5714286;
  min-width: 20px;
  padding: 1px 6px;
  position: relative;
  text-align: center;
}
:host .badge .arrow {
  border: 6px solid transparent;
  height: 0;
  position: absolute;
  width: 0;
}
:host .badge .arrow.arrow-top {
  border-bottom-color: inherit;
  bottom: 100%;
  left: 50%;
  margin-left: -6px;
}
:host .badge .arrow.arrow-right {
  border-left-color: inherit;
  left: 100%;
  margin-top: -6px;
  top: 50%;
}
:host .badge .arrow.arrow-bottom {
  border-top-color: inherit;
  left: 50%;
  margin-left: -6px;
  top: 100%;
}
:host .badge .arrow.arrow-left {
  border-right-color: inherit;
  margin-top: -6px;
  right: 100%;
  top: 50%;
}
:host .badge.border-radius-badge {
  border-radius: 10px;
}
:host .badge.border-radius-badge .arrow.arrow-right {
  margin-left: -2px;
}
:host .badge.border-radius-badge .arrow.arrow-left {
  margin-right: -2px;
}
:host .badge.success-badge {
  background: #008000;
  border-color: #008000;
}
:host .badge.info-badge {
  background: #00bfff;
  border-color: #00bfff;
}
:host .badge.warning-badge {
  background: #ff8c00;
  border-color: #ff8c00;
}
:host .badge.danger-badge {
  background: #dc143c;
  border-color: #dc143c;
}
:host .badge.outline-badge {
  background: none !important;
  color: inherit;
}
:host .badge.outline-badge.success-badge {
  color: #008000;
}
:host .badge.outline-badge.info-badge {
  color: #00bfff;
}
:host .badge.outline-badge.warning-badge {
  color: #ff8c00;
}
:host .badge.outline-badge.danger-badge {
  color: #dc143c;
}
:host .badge.custom-badge:not(.outline-badge) {
  color: #000 !important;
}
:host .badge.arrow-right-badge {
  margin-right: 6px;
}
:host .badge.arrow-left-badge {
  margin-left: 6px;
}
:host .badge.large-badge {
  padding: 6px 20px;
}
:host .badge.large-badge.border-radius-badge {
  border-radius: 15px;
}
:host .badge.medium-badge {
  padding: 3px 12px;
}
:host .badge.medium-badge.border-radius-badge {
  border-radius: 12px;
}
mat-icon :host .badge {
  bottom: 100%;
  left: 100%;
  margin: 0 0 -10px -10px;
  position: absolute;
  z-index: 1;
}
mat-icon :host .badge.top-left {
  left: auto;
  margin: 0 -10px -10px 0;
  right: 100%;
}
mat-icon :host .badge.bottom-left {
  bottom: auto;
  left: auto;
  margin: -10px -10px 0 0;
  right: 100%;
  top: 100%;
}
mat-icon :host .badge.bottom-right {
  bottom: auto;
  margin: -10px 0 0 -10px;
  top: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/rt-components/badge/badge.component.scss","webpack://./src/assets/sass/_variable.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;AADF;AAGE;EACE,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,oCCTM;EDUN,sBCRM;EDSN,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AADJ;AAGI;EACE,6BAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;AADN;AAGM;EACE,4BAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;AADR;AAGM;EACE,0BAAA;EACA,UAAA;EACA,gBAAA;EACA,QAAA;AADR;AAGM;EACE,yBAAA;EACA,SAAA;EACA,iBAAA;EACA,SAAA;AADR;AAGM;EACE,2BAAA;EACA,gBAAA;EACA,WAAA;EACA,QAAA;AADR;AAII;EACE,mBAAA;AAFN;AAKQ;EACE,iBAAA;AAHV;AAKQ;EACE,kBAAA;AAHV;AAOI;EACE,mBCpCU;EDqCV,qBCrCU;ADgChB;AAOI;EACE,mBCvCO;EDwCP,qBCxCO;ADmCb;AAOI;EACE,mBC1CU;ED2CV,qBC3CU;ADsChB;AAOI;EACE,mBC7CS;ED8CT,qBC9CS;ADyCf;AAOI;EACE,2BAAA;EACA,cAAA;AALN;AAOM;EACE,cCxDQ;ADmDhB;AAOM;EACE,cC1DK;ADqDb;AAOM;EACE,cC5DQ;ADuDhB;AAOM;EACE,cC9DO;ADyDf;AASM;EACE,sBAAA;AAPR;AAUI;EACE,iBAAA;AARN;AAUI;EACE,gBAAA;AARN;AAUI;EACE,iBAAA;AARN;AAUM;EACE,mBAAA;AARR;AAWI;EACE,iBAAA;AATN;AAWM;EACE,mBAAA;AATR;AAcI;EACE,YAAA;EACA,UAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;AAZN;AAcM;EACE,UAAA;EACA,uBAAA;EACA,WAAA;AAZR;AAcM;EACE,YAAA;EACA,UAAA;EACA,uBAAA;EACA,WAAA;EACA,SAAA;AAZR;AAcM;EACE,YAAA;EACA,uBAAA;EACA,SAAA;AAZR","sourcesContent":["@import '../../../assets/sass/variable';\r\n\r\n:host {\r\n  display: inline-block;\r\n\r\n  .badge {\r\n    background: main-color(A100);\r\n    border: 1px solid main-color(A100);\r\n    color: #fff;\r\n    font-size: .75rem;\r\n    font-family: $main-ff;\r\n    line-height: $main-lh;\r\n    min-width: 20px;\r\n    padding: 1px 6px;\r\n    position: relative;\r\n    text-align: center;\r\n\r\n    .arrow {\r\n      border: 6px solid transparent;\r\n      height: 0;\r\n      position: absolute;\r\n      width: 0;\r\n\r\n      &.arrow-top {\r\n        border-bottom-color: inherit;\r\n        bottom: 100%;\r\n        left: 50%;\r\n        margin-left: -6px;\r\n      }\r\n      &.arrow-right {\r\n        border-left-color: inherit;\r\n        left: 100%;\r\n        margin-top: -6px;\r\n        top: 50%;\r\n      }\r\n      &.arrow-bottom {\r\n        border-top-color: inherit;\r\n        left: 50%;\r\n        margin-left: -6px;\r\n        top: 100%;\r\n      }\r\n      &.arrow-left {\r\n        border-right-color: inherit;\r\n        margin-top: -6px;\r\n        right: 100%;\r\n        top: 50%;\r\n      }\r\n    }\r\n    &.border-radius-badge {\r\n      border-radius: 10px;\r\n\r\n      .arrow {\r\n        &.arrow-right {\r\n          margin-left: -2px;\r\n        }\r\n        &.arrow-left {\r\n          margin-right: -2px;\r\n        }\r\n      }\r\n    }\r\n    &.success-badge {\r\n      background: $success-color;\r\n      border-color: $success-color;\r\n    }\r\n    &.info-badge {\r\n      background: $info-color;\r\n      border-color: $info-color;\r\n    }\r\n    &.warning-badge {\r\n      background: $warning-color;\r\n      border-color: $warning-color;\r\n    }\r\n    &.danger-badge {\r\n      background: $danger-color;\r\n      border-color: $danger-color;\r\n    }\r\n    &.outline-badge {\r\n      background: none !important;\r\n      color: inherit;\r\n\r\n      &.success-badge {\r\n        color: $success-color;\r\n      }\r\n      &.info-badge {\r\n        color: $info-color;\r\n      }\r\n      &.warning-badge {\r\n        color: $warning-color;\r\n      }\r\n      &.danger-badge {\r\n        color: $danger-color;\r\n      }\r\n    }\r\n    &.custom-badge {\r\n      &:not(.outline-badge) {\r\n        color: #000 !important;\r\n      }\r\n    }\r\n    &.arrow-right-badge {\r\n      margin-right: 6px;\r\n    }\r\n    &.arrow-left-badge {\r\n      margin-left: 6px;\r\n    }\r\n    &.large-badge {\r\n      padding: 6px 20px;\r\n\r\n      &.border-radius-badge {\r\n        border-radius: 15px;\r\n      }\r\n    }\r\n    &.medium-badge {\r\n      padding: 3px 12px;\r\n\r\n      &.border-radius-badge {\r\n        border-radius: 12px;\r\n      }\r\n    }\r\n  }\r\n  mat-icon & {\r\n    .badge {\r\n      bottom: 100%;\r\n      left: 100%;\r\n      margin: 0 0 -10px -10px;\r\n      position: absolute;\r\n      z-index: 1;\r\n\r\n      &.top-left {\r\n        left: auto;\r\n        margin: 0 -10px -10px 0;\r\n        right: 100%;\r\n      }\r\n      &.bottom-left {\r\n        bottom: auto;\r\n        left: auto;\r\n        margin: -10px -10px 0 0;\r\n        right: 100%;\r\n        top: 100%;\r\n      }\r\n      &.bottom-right {\r\n        bottom: auto;\r\n        margin: -10px 0 0 -10px;\r\n        top: 100%;\r\n      }\r\n    }\r\n  }\r\n}\r\n","$main-fs: 14px;\r\n$main-ff: 'Open Sans', sans-serif;\r\n$main-fw: 400;\r\n$main-lh: 1.5714286;\r\n$module: 1.5714286rem;\r\n\r\n$second-ff: 'Nunito Sans', sans-serif;\r\n\r\n$animation: ease-in-out;\r\n\r\n$sidebar-width: 220px;\r\n\r\n$max543 : only screen and (max-width: 543px);\r\n$min544 : only screen and (min-width: 544px);\r\n$max767 : only screen and (max-width: 767px);\r\n$min768 : only screen and (min-width: 768px);\r\n$max991 : only screen and (max-width: 991px);\r\n$min992 : only screen and (min-width: 992px);\r\n$max1199 : only screen and (max-width: 1199px);\r\n$max2048 : only screen and (max-width: 2048px);\r\n$min1200 : only screen and (min-width: 1200px);\r\n\r\n$headers-ff: $second-ff;\r\n$headers-fw: 700;\r\n\r\n$success-color: #008000;\r\n$info-color: #00bfff;\r\n$warning-color: #ff8c00;\r\n$danger-color: #dc143c;\r\n\r\n$main-color: (\r\n  50 : #e8eaec,\r\n  100 : #c5cad0,\r\n  200 : #9ea7b1,\r\n  300 : #778391,\r\n  400 : #59697a,\r\n  500 : #3c4e62,\r\n  600 : #36475a,\r\n  700 : #2e3d50,\r\n  800 : #273546,\r\n  900 : #1a2534,\r\n  A100 : #5dade0,\r\n  A200 : #2694d9,\r\n  A400 : #0e7cc5,\r\n  A700 : #03568b,\r\n  contrast: (\r\n    50 : #000000,\r\n    100 : #000000,\r\n    200 : #000000,\r\n    300 : #000000,\r\n    400 : #ffffff,\r\n    500 : #ffffff,\r\n    600 : #ffffff,\r\n    700 : #ffffff,\r\n    800 : #ffffff,\r\n    900 : #ffffff,\r\n    A100 : #ffffff,\r\n    A200 : #ffffff,\r\n    A400 : #ffffff,\r\n    A700 : #ffffff,\r\n  )\r\n);\r\n@function main-color($key: $main-color) {\r\n  @return map-get($main-color, $key);\r\n}\r\n$accent-palette: (\r\n  50 : #ecf5fb,\r\n  100 : #cee6f6,\r\n  200 : #aed6f0,\r\n  300 : #8ec6e9,\r\n  400 : #75b9e5,\r\n  500 : #5dade0,\r\n  600 : #55a6dc,\r\n  700 : #4b9cd8,\r\n  800 : #4193d3,\r\n  900 : #3083cb,\r\n  A100 : #ffffff,\r\n  A200 : #dceeff,\r\n  A400 : #a9d5ff,\r\n  A700 : #90c9ff,\r\n  A800 : #EC4343,\r\n  contrast: (\r\n    50 : #000000,\r\n    100 : #000000,\r\n    200 : #000000,\r\n    300 : #000000,\r\n    400 : #000000,\r\n    500 : #ffffff,\r\n    600 : #000000,\r\n    700 : #000000,\r\n    800 : #000000,\r\n    900 : #ffffff,\r\n    A100 : #000000,\r\n    A200 : #000000,\r\n    A400 : #000000,\r\n    A700 : #000000,\r\n    A800 : #000000\r\n  )\r\n);\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
